import React, { Fragment, useState } from 'react';
import { useParams, useLocation, useNavigate } from '@reach/router';
import { useMutation, useQuery } from '@apollo/react-hooks';
import { Loader } from '@squirrellearningltd/go-teacher-components';
import BackLink from '../../components/BackLink';
import styles from './Subcategories.module.scss';
import ListSubcategory from '../../components/ListSubcategory';
import bookIcon from '../../images/book-icon.png';
import plusCircledSVG from '../../images/plus-circled.svg';
import Tabs from '../../components/Tabs';
import Tab from '../../components/Tab';
import { GET_SUBCATEGORIES } from '../../services/pack/graphql';
import { DELETE_TEMPLATE_CATEG_MUTATION } from '../../scenes/Packs/services/graphql';
import { HIDE_TEMPLATE_CATEG_MUTATION } from '../../scenes/Packs/services/graphql';

const TABS = {
    published: 1,
    hidden: 2,
};

const Subcategories = () => {
    const [selectedTab, setSelectedTab] = useState(TABS.published);
    const { packId } = useParams();
    const navigate = useNavigate();

    const { data, error, loading } = useQuery(GET_SUBCATEGORIES, {
        variables: {
            parentId: packId,
            hidden: selectedTab === TABS.hidden,
        },
    });

    const [deleteTemplateCateg] = useMutation(DELETE_TEMPLATE_CATEG_MUTATION, {
        update: (_, { data }) => {
            if (
                data.deleteBookTemplateCategory.errors &&
                data.deleteBookTemplateCategory.errors.length
            ) {
                alert(data.deleteBookTemplateCategory.errors[0]);
            }
        },
        refetchQueries: [
            { query: GET_SUBCATEGORIES, variables: { parentId: packId, hidden: false } },
            { query: GET_SUBCATEGORIES, variables: { parentId: packId, hidden: true } },
        ],
        awaitRefetchQueries: true,
    });

    const [hideTemplateCateg] = useMutation(HIDE_TEMPLATE_CATEG_MUTATION, {
        update: (_, { data }) => {
            if (
                data.hideBookTemplateCategory.errors &&
                data.hideBookTemplateCategory.errors.length
            ) {
                alert(data.hideBookTemplateCategory.errors[0]);
            }
        },
        refetchQueries: [
            { query: GET_SUBCATEGORIES, variables: { parentId: packId, hidden: false } },
            { query: GET_SUBCATEGORIES, variables: { parentId: packId, hidden: true } },
        ],
        awaitRefetchQueries: true,
    });

    const onDeleteCateg = (categ) => {
        let goAhead = window.confirm(
            `Are you sure you want to delete ${categ.name}?`
        );
        if (goAhead) {
            deleteTemplateCateg({
                variables: {
                    bookTemplateCategoryId: categ.id,
                },
            });
        }
    };

    const onHideCateg = (categ) => {
        const toggleHide = categ.hidden ? 'show' : 'hide';
        let goAhead = window.confirm(
            `Are you sure you want to ${toggleHide} ${categ.name}?`
        );
        if (goAhead) {
            hideTemplateCateg({
                variables: {
                    bookTemplateCategoryId: categ.id,
                    hidden: !categ.hidden,
                },
            });
        }
    };

    const subcategories = data?.bookTemplateSubcategories || [];

    return (
        <Fragment>
            <div className={styles.sectionHeader}>
                <div className={styles.TitleIconContainer}>
                    <h1 className={styles.HeaderTitle}>
                        Categories/Subcategories
                    </h1>
                    <img
                        width='20'
                        height='20'
                        src={bookIcon}
                        alt='book-icon-png'
                    />
                </div>
                <BackLink to='/packs' text='Back' />
            </div>
            <Tabs className={styles.TabsContainer}>
                <Tab
                    selected={selectedTab === TABS.published}
                    onClick={() => setSelectedTab(TABS.published)}
                >
                    Published
                </Tab>
                <Tab
                    selected={selectedTab === TABS.hidden}
                    onClick={() => setSelectedTab(TABS.hidden)}
                >
                    Hidden
                </Tab>
            </Tabs>
            <div>
                {error && <p>{error.message}</p>}
                {loading && <Loader />}
                <div className={styles.subcategoriesPanel}>
                    <div className={styles.writeSubcategoriesWrapper}>
                        {selectedTab === TABS.published && (
                            <div
                                onClick={() => navigate(`/subcategory/new/${packId}`)}
                                className={styles.writeSubcategoryCard}
                            >
                                <img
                                    width='40'
                                    src={plusCircledSVG}
                                    alt='plus-circled.svg'
                                />
                            </div>
                        )}
                        {data &&
                            subcategories.map((subcategory) => {
                                return (
                                    <ListSubcategory
                                        key={`subcategory-${subcategory.id}`}
                                        onClick={() => {
                                            navigate(
                                                `/subcategory/${subcategory.id}`
                                            );
                                        }}
                                        onDelete={() => onDeleteCateg(subcategory)}
                                        onHide={() => onHideCateg(subcategory)}
                                        subcategory={subcategory}
                                    />
                                );
                            })}
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default Subcategories;